import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { decodeToken, decodeTokenWithParam } from "../../../shared/helpers";
import { authContext } from "../../../shared/store/contexts";
import { themeContext } from "../../../shared/store/contexts/context.theme";

import Drawer from "../Drawer";
import { Header, LoggedInHeader } from "../Headers";

const LayoutStyle = styled.main`
  background: ${(props) => props.theme.background};
`;

const HeaderSelector = ({ isValid }) => {
  return isValid ? <LoggedInHeader /> : <Header />;
};

export const Layout = (props) => {
  const { theme } = useContext(themeContext);
  const { auth } = useContext(authContext);

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (auth && auth.token) {
      setIsValid(decodeTokenWithParam(auth.token));
    } else {
      setIsValid(decodeToken());
    }
  }, [auth]);

  return (
    <LayoutStyle theme={theme}>
      <div className="md:hidden">
        <Drawer />
      </div>
      <HeaderSelector isValid={isValid} />
      {props.children}
    </LayoutStyle>
  );
};
